module.exports = __webpack_public_path__ + "static/media/desktop-frame-about.0377ac9b.png";